import { render, staticRenderFns } from "./ProfilePrivacyData.vue?vue&type=template&id=95054b92"
import script from "./ProfilePrivacyData.vue?vue&type=script&lang=js"
export * from "./ProfilePrivacyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports